  // Prevent Double Submits
document.addEventListener("turbo:load", function () {
  // Reset all submitting states on page load (fixes browser back/forward issues)
  resetSubmittingStates();

  document.querySelectorAll("form").forEach(form => {
    form.addEventListener("submit", (e) => {
      // Prevent if already submitting
      if (form.classList.contains("is-submitting")) {
        e.preventDefault();
      }

      // Add class to hook our visual indicator on
      form.classList.add("is-submitting");
    });
  });

  document.querySelectorAll("[data-prevent-doubleclick]").forEach(link => {
    link.addEventListener("click", (e) => {
      // Prevent if already submitting
      if (link.classList.contains("is-submitting")) {
        e.preventDefault();
        return false;
      }
      // Add class to hook our visual indicator on
      link.classList.add("is-submitting");
    });
  });
});

// Reset submitting states when navigating back/forward
document.addEventListener("turbo:before-cache", function () {
  resetSubmittingStates();
});

// Reset on page show (handles browser back/forward)
document.addEventListener("turbo:before-render", function () {
  resetSubmittingStates();
});

// Additional event for browser back/forward (most important for bfcache)
window.addEventListener("pageshow", function(event) {
  // Only reset if page was loaded from cache (back/forward navigation)
  if (event.persisted) {
    resetSubmittingStates();
  }
});

// Helper function to reset all submitting states
function resetSubmittingStates() {
  document.querySelectorAll(".is-submitting").forEach(element => {
    element.classList.remove("is-submitting");
  });
}
